export default function StockhamBuildingDocs() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStockhamBuildingDocs">
          <i className="fa-solid fa-building fa-2xl feature-icon af-icon"></i>
          <b>Stockham Building documents now available</b>
          <span className="badge bg-primary">DOCS</span>
        </button>
      </h2>
      <div id="collapseStockhamBuildingDocs" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">
            <p>
        Documents related to the Stockham Building discussion at the 4/21/2026 Council meeting are now available for public review.
        </p>
          <p>
          <a href="../docs/council/related/Stockham-Building-2025-01-14-Structural-Condition-Assessment-Report-Final.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;&nbsp;Ramtin Group Structural Condition Assessment Report Dated 1/14/25
          </a>
          </p>
          <p>
          <a href="../docs/council/related/Stockham-Building-2025-05-01-GA-Memo.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;&nbsp;Gilmore &amp; Associates Memo Dated 5/1/25
          </a>
          </p>
          <p>
          <a href="../docs/council/related/Stockham-Building-Treacy-Brothers-Final-Estimate.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;&nbsp;Treacy Brothers Final Estimate 
          </a>
          </p>
         

        </div>
      </div>
    </div>
  );
}
